import React from "react";
import { cn } from "@/lib/utils";

const MAP: Record<string, [string, string]> = {
  unused: ["Unused", "bg-[#DCFCE7] text-[#15803D]"],
  reserved: ["In use", "bg-[#FEF3C7] text-[#B45309]"],
  used: ["Used", "bg-[#E0E7FF] text-[#1B365D]"],
  expired: ["Expired", "bg-[#F1F5F9] text-[#64748B]"],
  voided: ["Voided", "bg-[#FEE2E2] text-[#B91C1C]"],
  pending_payment: ["Pending payment", "bg-[#FEF3C7] text-[#B45309]"],
  awaiting_approval: ["Paid · awaiting approval", "bg-[#CCFBF1] text-[#0F766E]"],
  invoice_review: ["Invoice · awaiting approval", "bg-[#FFF1CC] text-[#9A5B00]"],
  issuing: ["Issuing", "bg-[#FEF3C7] text-[#B45309]"],
  issued: ["Codes issued", "bg-[#DCFCE7] text-[#15803D]"],
  cancelled: ["Cancelled", "bg-[#F1F5F9] text-[#64748B]"],
  new: ["New", "bg-[#E0E7FF] text-[#1B365D]"],
  in_progress: ["In progress", "bg-[#FEF3C7] text-[#B45309]"],
  awaiting_records: ["Awaiting records", "bg-[#FFEDD5] text-[#C2410C]"],
  on_hold: ["On hold", "bg-[#F1F5F9] text-[#475569]"],
  review: ["In review", "bg-[#CCFBF1] text-[#0F766E]"],
  report_ready: ["Report ready", "bg-[#DCFCE7] text-[#15803D]"],
  delivered: ["Complete", "bg-[#1B365D] text-white"],
  locked: ["Locked (24h)", "bg-[#FEE2E2] text-[#B91C1C]"],
  submitted: ["Submitted", "bg-[#E0E7FF] text-[#1B365D]"],
};

export const CASE_STATUS_LABEL = (s: string) => MAP[s]?.[0] || s;

export function StatusBadge({ status, className, testId }: { status: string; className?: string; testId?: string }) {
  const [label, cls] = MAP[status] || [status, "bg-slate-100 text-slate-600"];
  return (
    <span data-testid={testId} className={cn("inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold whitespace-nowrap", cls, className)}>
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
}
